import { PURCHASE_DETAIL_PATHNAME } from 'my-purchases/constants/paths'
import { PRODUCT_STATUS } from 'my-purchases/constants/productStatus'
import type { PurchaseResponse } from 'my-purchases/types/purchaseList'
import { hasSomeItemsByStatus } from 'my-purchases/utils/product'

export const normalizeData = ({
	purchases,
}: { purchases: PurchaseResponse[] }) =>
	purchases.map((purchase) => {
		const { purchaseId, type, orders = [] } = purchase

		const link = `${PURCHASE_DETAIL_PATHNAME}?type=${type}&purchaseId=${purchaseId}`

		const normalizedOrders = orders.map((order) => ({
			...order,
			hasSomeReturnedItems: hasSomeItemsByStatus(
				order.lines,
				PRODUCT_STATUS.RETURNED
			),
			hasSomeReturnRequestedItems: hasSomeItemsByStatus(
				order.lines,
				PRODUCT_STATUS.RETURN_REQUESTED
			),
			hasSomeOutOfStockItems: hasSomeItemsByStatus(
				order.lines,
				PRODUCT_STATUS.OUT_OF_STOCK
			),
		}))

		return {
			...purchase,
			link,
			orders: normalizedOrders,
		}
	})
